;(function() {
  'use strict'

  service.$inject = ["TransientStorage", "UserStorage", "userService"];
  angular.module('core.services').factory('autocompleteService', service)

  /* @ngInject */
  function service(TransientStorage, UserStorage, userService) {
    return {
      getStorage: getStorage,
    }

    function getStorage() {
      var isLoggedIn = userService.loggedIn()

      return isLoggedIn ? new UserStorage() : new TransientStorage()
    }
  }
})()
